// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-i_eR","catalogByServiceItem__title":"c-i_eS"};